import {
  Feature,
  getIntervalPathParam,
  getQuotaPathParam,
  PlanInterval,
  Subscription,
  SubscriptionSource,
} from '../models';
import { useQuery } from '../routes';
import store from '../store';

// maximum amount that recurly allow for a payment
export const MAX_TOTAL_AMOUNT = 1000000;

export const BUSINESS_EMAIL = 'mailto:business@katalon.com';

// promotion banner constant
export const PROMOTION_BANNER_SHOW_DESC_WIDTH = 960;
export const PROMOTION_BANNER_COUNTDOWN_FORMAT_WIDTH = 606;

export const getQuotaFromPathParam = (feature: Feature) => {
  const { get } = useQuery();
  const quota = get(getQuotaPathParam(feature));
  return quota ? Number(quota) : undefined;
};

export const getCycleFromPathParam = (feature: Feature): PlanInterval | undefined => {
  const { get } = useQuery();
  const interval = get(getIntervalPathParam(feature));
  if (interval) {
    return PlanInterval.fromString(interval);
  }
  return undefined;
};

export type TrackingPayload = Record<string, unknown>;

export const sendTrackingData = (
  eventName: string,
  accountId: number,
  organizationId?: number,
  additionalProps: TrackingPayload = {},
) => {
  const currentState = store.getState();
  const user = currentState.auth.user || undefined;
  const accountTotalMembers = Object.values(
    currentState.accountUsers.entities,
  ).filter(it => it !== undefined && it.accountId === accountId).length;

  window.analytics?.track(
    eventName,
    {
      id: user?.id,
      email: user?.email,
      account_id: accountId,
      timestamp: new Date().toISOString(),
      ...(
        organizationId !== undefined
          ? { organization_id: organizationId }
          : {}
      ),
      role: user?.roles,
      total_members: accountTotalMembers,
      ...additionalProps,
    },
  );
};

export const formatUSPrice = (price: number) => price.toLocaleString('en-US');

export const getQuota = (
  subscription: Subscription,
  chosenQuota: number,
  chosenInterval: any,
): number => {
  if (subscription
    && subscription.source === SubscriptionSource.RECURLY
    && subscription.billingInterval !== chosenInterval) {
    return subscription.quota + chosenQuota;
  }

  return chosenQuota;
};
